/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as WeighbridgeRouteImport } from './routes/weighbridge'
import { Route as ScanRouteImport } from './routes/scan'
import { Route as PrivacyRouteImport } from './routes/privacy'
import { Route as LoginRouteImport } from './routes/login'
import { Route as InboundRouteImport } from './routes/inbound'
import { Route as IndexRouteImport } from './routes/index'

const WeighbridgeRoute = WeighbridgeRouteImport.update({
  id: '/weighbridge',
  path: '/weighbridge',
  getParentRoute: () => rootRouteImport,
} as any)
const ScanRoute = ScanRouteImport.update({
  id: '/scan',
  path: '/scan',
  getParentRoute: () => rootRouteImport,
} as any)
const PrivacyRoute = PrivacyRouteImport.update({
  id: '/privacy',
  path: '/privacy',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const InboundRoute = InboundRouteImport.update({
  id: '/inbound',
  path: '/inbound',
  getParentRoute: () => rootRouteImport,
} as any)
const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/inbound': typeof InboundRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/scan': typeof ScanRoute
  '/weighbridge': typeof WeighbridgeRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/inbound': typeof InboundRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/scan': typeof ScanRoute
  '/weighbridge': typeof WeighbridgeRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/inbound': typeof InboundRoute
  '/login': typeof LoginRoute
  '/privacy': typeof PrivacyRoute
  '/scan': typeof ScanRoute
  '/weighbridge': typeof WeighbridgeRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths: '/' | '/inbound' | '/login' | '/privacy' | '/scan' | '/weighbridge'
  fileRoutesByTo: FileRoutesByTo
  to: '/' | '/inbound' | '/login' | '/privacy' | '/scan' | '/weighbridge'
  id:
    | '__root__'
    | '/'
    | '/inbound'
    | '/login'
    | '/privacy'
    | '/scan'
    | '/weighbridge'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  InboundRoute: typeof InboundRoute
  LoginRoute: typeof LoginRoute
  PrivacyRoute: typeof PrivacyRoute
  ScanRoute: typeof ScanRoute
  WeighbridgeRoute: typeof WeighbridgeRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/weighbridge': {
      id: '/weighbridge'
      path: '/weighbridge'
      fullPath: '/weighbridge'
      preLoaderRoute: typeof WeighbridgeRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/scan': {
      id: '/scan'
      path: '/scan'
      fullPath: '/scan'
      preLoaderRoute: typeof ScanRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/privacy': {
      id: '/privacy'
      path: '/privacy'
      fullPath: '/privacy'
      preLoaderRoute: typeof PrivacyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/inbound': {
      id: '/inbound'
      path: '/inbound'
      fullPath: '/inbound'
      preLoaderRoute: typeof InboundRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  InboundRoute: InboundRoute,
  LoginRoute: LoginRoute,
  PrivacyRoute: PrivacyRoute,
  ScanRoute: ScanRoute,
  WeighbridgeRoute: WeighbridgeRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()
